import modal from '@/utils/modal'
import Page from './index.vue'

export default function openInfoPageModal (titlePhrase, contentPhrase) {
    const m = modal.create(Page, true);
    m.app.setOverridePhrases({
        title: titlePhrase,
        content: contentPhrase,
    });
}
